export const PARTNERSHIP_INFOS = {
	ANS: [
        'NÚMERO DE REGISTRO OFICIAL DO PLANO DE SAÚDE NA ANS (AGÊNCIA NACIONAL DE SAÚDE SUPLEMENTAR).'
    ],
    EXECUTING_PROVIDER_CODE: [
        'NÚMERO DE IDENTIFICAÇÃO EXCLUSIVO (A "MATRÍCULA") QUE A INSTITUIÇÃO OU O MÉDICO RECEBE DO CONVÊNIO QUANDO SE CREDENCIA A ELE.'
    ]
}